import { ClearOutlined, SearchOutlined,  } from '@ant-design/icons'
import { Button, Card, Checkbox, Col, DatePicker, Input, InputNumber, Row, Space, Tooltip } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import LabelWrapper from '../UI/LabelWrapper'

export const EducationSearch = (props) => {

  const [rangePickerValue, setRangePickerValue] = useState([]);

  useEffect(() => {
    const startDate = props.searchModel["startDate"];
    const endDate = props.searchModel["endDate"];
    setRangePickerValue([!!startDate ? moment(startDate): undefined, !!endDate ? moment(endDate) : undefined]);
  }, [props])

  return (
    <Card className='search_card my_custom_search_card'
     title={props.title}
     actions={[
        <Button onClick={props.onSearchSubmit}><SearchOutlined key="filter" />Filtriraj</Button>,
        <Button onClick={(e) => props.onClearFilters(e)}><ClearOutlined key="clearFilter"/>Očisti filtere</Button>,
     ]}
    >
      <Row gutter={[16, 16]}>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Input 
            id="orgName"
            addonBefore={"Organizator"} 
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["orgName"]}
          />
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <LabelWrapper label="Razdoblje">
            <DatePicker.RangePicker 
              onChange={(e) => props.userInputHandler(e)} 
              format={"DD.MM.YYYY."} 
              allowClear={false} 
              value={rangePickerValue}
              style={{width: "100%"}}
            />
          </LabelWrapper>
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Tooltip title="Zbog mogućnosti pretraživanja više područja odjednom, nemoguće je unjeti razmak">
            <Input
              id="eduActivityAreas"
              addonBefore={"Područje"}
              onChange={(e) => props.userInputHandler(e)}
              value={props.searchModel["eduActivityAreas"]}
              
              />
          </Tooltip>
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Input 
            id="eduEducatorName"
            addonBefore={"Ime i prezime edukatora"}
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["eduEducatorName"]}
          />
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Input
            type="number"
            id="eduDuration"
            addonBefore={"Trajanje u satima"}
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["eduDuration"]} 
          />
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Input
            type="number"
            id="eduDurationInDays"
            addonBefore={"Trajanje u danima"}
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["eduDurationInDays"]}
          />
        </Col>
        <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
          <Checkbox 
            id="isAreaA" 
            onChange={(e) => props.userInputHandler(e)} 
            checked={props.searchModel["isAreaA"]}
          >
              Područje s oznakom A
          </Checkbox>
        </Col>
      </Row>
    </Card>
  )
}

EducationSearch.defaultProps = {
    title: "Pretraga"
}
